import { TIME_RANGE } from '../constants/timeRange';

type Option = { value: string; label: string };

const optionKeys = {
  today: 'Today',
  last7Days: 'Last 7 Days',
  last30Days: 'Last 30 Days',
  yearly: 'Yearly',
  all: 'All',
  active: 'Active',
  inactive: 'Inactive',
  draft: 'Draft'
} as const;

type OptionKey = keyof typeof optionKeys;

const buildOptions = (
  t: (key: string) => string,
  keys: OptionKey[],
  namespace?: string
): Option[] =>
  keys.map((key) => {
    let value;
    switch (key) {
      case 'last7Days':
        value = TIME_RANGE.WEEKLY;
        break;
      case 'last30Days':
        value = TIME_RANGE.MONTHLY;
        break;
      case 'yearly':
        value = TIME_RANGE.YEARLY;
        break;
      default:
        value = optionKeys[key];
    }

    const translationKey = namespace ? `${namespace}.${key}` : key;

    return {
      value,
      label: t(translationKey)
    };
  });

// Day options
export const getDayOptions = (t: (key: string) => string) =>
  buildOptions(t, ['today', 'last7Days', 'last30Days', 'yearly']);

// Health plan options with namespace
export const getHealthPlanOptions = (t: (key: string) => string) =>
  buildOptions(t, ['all', 'active', 'inactive', 'draft']);

// Active users options
export const getActiveUsersOptions = (t: (key: string) => string) =>
  buildOptions(t, ['today', 'last7Days', 'last30Days', 'yearly']);

// Monthly options
export const getMonthlyOptions = (t: (key: string) => string) =>
  buildOptions(t, ['today', 'last7Days', 'last30Days']);

// Yearly options
export const getYearlyOptions = (t: (key: string) => string) =>
  buildOptions(t, ['last7Days', 'last30Days', 'yearly']);
